import { Page } from '@components';
import { routes } from '@routes';
import { AddAccessFlowPageContent } from '@AccessFlows/organisms/AddAccessFlowPageContent';

export function AddAccessFlowPage() {
  return (
    <Page
      specialLayout
      title="Create Access Flow"
      breadcrumbs={[
        {
          label: routes.AccessFlows.label,
          href: routes.AccessFlows.path,
        },
      ]}
    >
      <AddAccessFlowPageContent paths={{ donePath: routes.AccessFlows.path }} />
    </Page>
  );
}
